export default __webpack_public_path__ + "images/loggedout/icons/google_icon-c6ddf0a0e9a4f26e332f82519f6686b1.png";